import { atom, useAtom } from 'jotai';

type DashboardState = 'none' | 'loading' | 'overdue' | 'success' | 'failure';

const dashboardStateAtom = atom<DashboardState>('none');

export const useDashboardState = () => useAtom(dashboardStateAtom);
